import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { get } from "helpers/api_helper";
import { isImageDocument, sortDocumentsByName } from "helpers/customPageDocuments";

const DownloadAllImagesButton = ({ documents = [] }) => {
  const images = useMemo(
    () => sortDocumentsByName((documents || []).filter(isImageDocument)),
    [documents]
  );
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");

  if (!images.length) return null;

  const onDownload = async () => {
    if (downloading) return;
    setDownloading(true);
    setError("");
    try {
      const ids = images.map((doc) => doc.id).join(",");
      const blob = await get(`/documents/download-zip?ids=${ids}`, { responseType: "blob" });
      const type = String(blob?.type || "");
      if (type.includes("json") || type.includes("text")) {
        const text = await blob.text();
        let message = "Download failed";
        try {
          message = JSON.parse(text).message || message;
        } catch {
          message = text || message;
        }
        throw new Error(message);
      }
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "ColdBlock-Images.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      const data = e?.response?.data;
      let message = e?.message || "Download failed";
      if (data && typeof data.text === "function") {
        try {
          const parsed = JSON.parse(await data.text());
          message = parsed.message || message;
        } catch {
          /* keep message */
        }
      } else if (data?.message) {
        message = data.message;
      }
      setError(message);
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="mb-3">
      <button
        type="button"
        className="cta-button"
        onClick={onDownload}
        disabled={downloading}
      >
        {downloading ? "Preparing download…" : "Download All Images"}
      </button>
      {error ? <div className="text-danger small mt-2">{error}</div> : null}
    </div>
  );
};

DownloadAllImagesButton.propTypes = {
  documents: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      fileName: PropTypes.string,
      mimeType: PropTypes.string,
    })
  ),
};

export default DownloadAllImagesButton;
